import React, { useState, useEffect } from 'react';
import Select from '@material-ui/core/Select';
import DeveloperBoard from './Developer'; // 하나만 사용

function TabControl(props) {
  const initialTab = props.SelectedTab || 'Developer';
  const [boardType, setBoardType] = useState(initialTab);
  const [categories, setCategories] = useState(['ALL', 'NoData']);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [num, setNum] = useState(0);

  // API 엔드포인트 설정
  const getApiEndpoints = (type) => ({
    apiFetchPage: `/request/Select${type}BoardPage`,
    apiFetchPageList: `/request/Select${type}BoardPageList`,
    apiReadNews: `/request/Read${type}Board`,
    apiReadComments: `/request/Read${type}Comments`,
    apiIncreaseCount: `/request/${type}SearchCountPlus`,
    apiDeleteNews: `/request/Delete${type}Board`,
    apiDeleteComment: `/request/Delete${type}Comment`,
    apiInsertComment: `/request/Insert${type}Comment`
  });

  const handleCategorySelect = (e) => {
    setSelectedCategory(e.target.value);
  };

  const fetchCategories = async (tab) => {
    try {
      const response = await fetch(`/request/${tab}CategoryList`, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      const data = await response.json();
      setCategories(data);
    } catch (err) {
      console.error(`${tab}CategoryList Error:`, err);
    }
  };

  const handleTabClick = (tabName) => {
    setBoardType(tabName);
    setSelectedCategory('ALL');
    fetchCategories(tabName);
  };

  useEffect(() => {
    fetchCategories(initialTab);
  }, []);

  const tabs = [
    { id: 'Developer', label: '프로그래밍' },
    { id: 'Modeler', label: '모델링' },
    { id: 'Design', label: '디자인' },
    { id: 'Infra', label: '인프라' },
    { id: 'Media', label: '미디어' },
    { id: 'Plan', label: '기획/설계' },
    { id: 'Work', label: '업무일지' }
  ];

  return (
    <div className='TabPage'>
      <ul className="SubNavCategory">
        {tabs.map(tab => (
          <li key={tab.id}>
            <a 
              className={boardType === tab.id ? 'TabActive' : ''} 
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.label}
            </a>
          </li>
        ))}
        
        <li style={{ float: 'right', padding: '9px 14px' }}>
          <Select 
            style={{ width: "150px" }} 
            value={selectedCategory}
            onChange={handleCategorySelect}
          >
            <option value='ALL'>ALL</option>
            {categories.map((category, i) => (
              <option key={i} value={category.notice_category}>
                {category.notice_category}
              </option>
            ))}
          </Select>
        </li>
      </ul>

      <div>
        <DeveloperBoard
          {...getApiEndpoints(boardType)}
          data={{ num }}
          boardType={boardType}
          pageSize={10}
          selectedCategory={selectedCategory}
          onCategoryChange={setSelectedCategory}
          args={props.args}
        />
      </div>
    </div>
  );
}

export default TabControl;